import React from 'react';
import moment from 'moment';
import Box from '../../../../components/Box';
import TextEditor from '../../../../components/TextEditor';
import { getPlayerHeight } from '../../../../utils';
import './PlayersListItem.css';
import PlayersListItemStats from '../PlayersListItemStats';

class PlayersListItem extends React.Component {
  handleImageError = (e) => {
    e.target.src = 'https://s3.amazonaws.com/s4usitesimages/images/anon-avatar.png';
  };

  getPlayerHeader() {
    const {
      playerData
    } = this.props;

    return (
      <div>
        { playerData.jerseyNumber >= 0 &&
          <span className="jersey-number">#{ playerData.jerseyNumber } </span>
        }
        { `${playerData.lastName} ${playerData.firstName}` }
        <ul className="player-info">
          { playerData.position &&
            <li>
              { playerData.position.shortName }
            </li>
          }
          { playerData.height &&
            <li>
              { getPlayerHeight(playerData.height) }
            </li>
          }
          { playerData.mainNationality &&
            <li>
              { playerData.mainNationality.name }
            </li>
          }
          { playerData.birthDate  &&
            <li>
              { moment(playerData.birthDate).toNow(true) } old
            </li>
          }
        </ul>
      </div>
    );
  }

  onPlayerContentChange(content) {
    const { onPlayerContentChange, playerData } = this.props;
    onPlayerContentChange(playerData.id, content);
  }

  onPlayerConfigurationChange(checked) {
    const { onPlayerConfigurationChange, playerData } = this.props;
    onPlayerConfigurationChange(playerData.id, {
      breakPageAfter: checked
    });
  }

  render() {
    const {
      playerData,
      combinedStats,
      showPlayersStatsAllGames,
      showPlayersStatsWonGames,
      showPlayersStatsLostGames,
      showPlayersStatsHomeGames,
      showPlayersStatsAwayGames,
      showPlayersStatsTotal,
      season,
      league,
      team,
      editMode
    } = this.props;

    const playerId = playerData.id;

    return (
      <Box title={ this.getPlayerHeader() }
           className={ `page-break-inside-avoid ${playerData.playerConfiguration && playerData.playerConfiguration.breakPageAfter ? 'page-break-after' : ''}` }>
        <table className="table">
        <tbody>
        <tr style={{ verticalAlign: 'top' }}>
          <td style={{ width: '170px' }}>
            <img src={ (playerData.profilePhoto && playerData.profilePhoto !== '') ? playerData.profilePhoto
                             : `https://s3.amazonaws.com/s4usitesimages/images/anon-avatar.png` }
                 alt={ playerData.lastName }
                 style={{ width: '160px' }}
                 onError={ this.handleImageError }/>
          </td>
          <td>
            <TextEditor id={ `player_text_${playerId}` }
                        playerId={ playerId }
                        content={ playerData.content }
                        printMode={ !editMode }
                        onChange={ (content) => this.onPlayerContentChange(content) } />
            { editMode &&
              <div className="form-group hidden-print" style={{ marginTop: '-10px', marginBottom: 0 }}>
                <div className="checkbox" style={{ marginBottom: '0'}}>
                  <label>
                    <input type="checkbox"
                           defaultChecked={ playerData.playerConfiguration && playerData.playerConfiguration.breakPageAfter }
                           onChange={ (e) => this.onPlayerConfigurationChange(e.target.checked) } />
                    <small>Break page after { `${playerData.lastName} ${playerData.firstName}` } when printing</small>
                  </label>
                </div>
              </div>
            }
          </td>
        </tr>
        </tbody>
        </table>
        { !editMode &&
            (showPlayersStatsAllGames
            || showPlayersStatsWonGames
            || showPlayersStatsLostGames
            || showPlayersStatsHomeGames
            || showPlayersStatsAwayGames
            || showPlayersStatsTotal) &&
          <div style={{ clear: 'left' }}>
            <PlayersListItemStats { ...{ showPlayersStatsAllGames,
                                          showPlayersStatsWonGames,
                                          showPlayersStatsLostGames,
                                          showPlayersStatsHomeGames,
                                          showPlayersStatsAwayGames,
                                          showPlayersStatsTotal } }
                                  playerId={ playerId }
                                  url={ `v1/stats/team/players_average_stats_home_away_won_lost/?season=${season}&league=${league}&team=${team}&combined=${combinedStats}` }
                                  shouldComponentUpdate={ function(nextProps) {
                                    const {
                                      showPlayersStatsAllGames,
                                      showPlayersStatsWonGames,
                                      showPlayersStatsLostGames,
                                      showPlayersStatsHomeGames,
                                      showPlayersStatsAwayGames,
                                      showPlayersStatsTotal
                                    } = this.props;

                                    return (
                                      showPlayersStatsAllGames !== nextProps.showPlayersStatsAllGames
                                      || showPlayersStatsWonGames !== nextProps.showPlayersStatsWonGames
                                      || showPlayersStatsLostGames !== nextProps.showPlayersStatsLostGames
                                      || showPlayersStatsHomeGames !== nextProps.showPlayersStatsHomeGames
                                      || showPlayersStatsAwayGames !== nextProps.showPlayersStatsAwayGames
                                      || showPlayersStatsTotal !== nextProps.showPlayersStatsTotal
                                    );
                                  } }
                                   />
          </div>
        }
      </Box>
    );
  }
}

export default PlayersListItem;



// WEBPACK FOOTER //
// ./src/features/scout-report/components/PlayersListItem/PlayersListItem.js